import { fromPairs } from 'lodash';
import * as form from '../form';

export const foreignActivitiesDirect = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        InterestTypes: form.checkboxgroup(xitem.InterestTypes),
        InterestType: form.text(xitem.InterestType),
        Acquired: form.datecontrol(xitem.Acquired),
        HowAcquired: form.textarea(xitem.HowAcquired),
        Cost: form.number(xitem.Cost),
        CostEstimated: form.checkbox(xitem.CostEstimated),
        Value: form.number(xitem.Value),
        ValueEstimated: form.checkbox(xitem.ValueEstimated),
        Relinquished: form.datecontrol(xitem.Relinquished),
        RelinquishedNotApplicable: form.notapplicable(xitem.RelinquishedNotApplicable),
        Explanation: form.textarea(xitem.Explanation),
        CoOwners: form.coowners(xitem.CoOwners),
        // pvq
        InterestOwnerType: form.radio(xitem.InterestOwnerType),
        DependentChildrenName: form.name(xitem.DependentChildrenName),
        FinancialInterestType: form.radio(xitem.FinancialInterestType),
        FinancialInterestTypeOtherExplanation: form.textarea(xitem.FinancialInterestTypeOtherExplanation),
        RealEstateType: form.radio(xitem.RealEstateType),
        RealEstateTypeOtherExplanation: form.textarea(xitem.RealEstateTypeOtherExplanation),
        RealEstateTypeLocation: form.location(xitem.RealEstateTypeLocation),
        HowRealEstateAcquired: form.radio(xitem.HowRealEstateAcquired),
        HowAcquiredOtherExplanation: form.textarea(xitem.HowAcquiredOtherExplanation),
        HasCoOwners: form.branch(xitem.HasCoOwners),
        StillOwned: form.branch(xitem.StillOwned),
        RelinquishedValue: form.number(xitem.RelinquishedValue),
        Country: form.country(xitem.Country),
        ForeignInterestAcquired: form.datecontrol(xitem.ForeignInterestAcquired),
        HowForeignInterest: form.radio(xitem.HowForeignInterest),
        ForeignInterestOtherExplanation: form.textarea(xitem.ForeignInterestOtherExplanation),
        ForeignInterestPurchaseValue: form.number(xitem.ForeignInterestPurchaseValue),
        ForeignInterestStillOwned: form.branch(xitem.ForeignInterestStillOwned),
        ForeignInterestCurrentValue: form.number(xitem.ForeignInterestCurrentValue),
        ForeignInterestSoldValue: form.number(xitem.ForeignInterestSoldValue),
        ForeignInterestHowRelinquished: form.textarea(xitem.ForeignInterestHowRelinquished),
        ForeignInterestHowRelinquishedOtherExplanation: form.textarea(xitem.ForeignInterestHowRelinquishedOtherExplanation),
        ForeignInterestSoldDate: form.datecontrol(xitem.ForeignInterestSoldDate),
        ForeignInterestControl: form.radio(xitem.ForeignInterestControl),
        ForeignInterestControlOtherExplanation: form.textarea(xitem.ForeignInterestControlOtherExplanation),
        ForeignInterestRelationship: form.textarea(xitem.ForeignInterestRelationship),
        ForeignInterestControllerName: form.name(xitem.ForeignInterestControllerName),
        ForeignInterestCountry: form.country(xitem.ForeignInterestCountry),
        ForeignInterestCountryNotApplicable: form.notapplicable(xitem.ForeignInterestCountryNotApplicable),
        ForeignInterestControlAddressNotApplicable: form.notapplicable(xitem.ForeignInterestControlAddressNotApplicable),
        ForeignInterestControlAddressInUsaNotApplicable: form.notapplicable(xitem.ForeignInterestControlAddressInUsaNotApplicable),
        ForeignInterestControlAddress: form.location(xitem.ForeignInterestControlAddress),
        ForeignInterestAnotherControl: form.branch(xitem.ForeignInterestAnotherControl),
        ForeignInterestAnotherControlExplanation: form.textarea(xitem.ForeignInterestAnotherControlExplanation),
        ForeignInterestControlCompanyName: form.textarea(xitem.ForeignInterestControlCompanyName),
        ForeignInterestRelationshipOtherExplanation: form.textarea(xitem.ForeignInterestRelationshipOtherExplanation),
      },
    };
  });
  return {
    HasInterests: form.branch(data.HasInterests),
    List: form.collection(items, (data.List || {}).branch),
  };
};
